import { Badge } from "@/shared/ui/badge";
import { useTranslation } from "@/shared/i18n";
import type { TemplateStatus } from "../api";

interface Props {
  status: TemplateStatus;
}

export function StatusBadge({ status }: Props) {
  const { t } = useTranslation("psdTemplates");
  const label = t(`status.${status}`);
  if (status === "READY") {
    return <Badge className="bg-emerald-600 hover:bg-emerald-600/90">{label}</Badge>;
  }
  if (status === "ARCHIVED") {
    return <Badge variant="secondary">{label}</Badge>;
  }
  return <Badge variant="outline">{label}</Badge>;
}
